import * as api from '../dealerApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  dealerActionCreators,
  DealerActionKeys,
  FetchDealerPowerAssessments,
  IPowerAssessment
  } from '..';

function* fetchDealerPowerAssessmentsSaga(action: FetchDealerPowerAssessments) {
  const pa: IPowerAssessment[] = yield call(api.fetchPowerAssessments, action.payload.accountNum);
  yield put(dealerActionCreators.setPowerAssessments(pa));
}

export function* watchFetchDealerPowerAssessments() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_POWER_ASSESSMENTS, fetchDealerPowerAssessmentsSaga);
}
